import React, { Component } from 'react';
import onClickOutside from 'react-onclickoutside';

import {
  SHARE_MENU_ACTION_EMBED,
  SHARE_MENU_ACTION_EMBED_THUMB_LINK,
} from 'constants/events';
import * as analytics from 'utilities/analytics';
import { getAnimatedPreview } from 'utilities/video';

import DropdownMenuWithItems from './dropdown-menu-with-items';
import EmbedCodeDropdown from './embed-code-dropdown';
import EmbedThumbnailDropdown from './embed-thumbnail-dropdown';

import './styles.less';

const DEFAULT_STATE = {
  isEmbedDropdownOpen: false,
  isGifDropdownOpen: false,
};

class ShareDropdownMenu extends Component {
  static defaultProps = {
    show: false,
    onHide: () => {},
    align: 'left',
    vAlign: 'auto',
  };

  state = DEFAULT_STATE;

  render() {
    const {
      currentUserIsOwner,
      hasGmailAccount,
      video,
      show: dropdownOpen,
      align,
      vAlign,
    } = this.props;

    const { isEmbedDropdownOpen, isGifDropdownOpen } = this.state;
    const showLinkedGif = Boolean(getAnimatedPreview(video));

    return (
      <div className="share-video-share-dropdown-menu">
        {dropdownOpen && (
          <DropdownMenuWithItems
            show={dropdownOpen}
            align={align}
            vAlign={vAlign}
            additionalClass="share-dropdown"
            hasGmailAccount={hasGmailAccount}
            currentUserIsOwner={currentUserIsOwner}
            handleEmbedCodeClick={this.handleEmbedCodeClick}
            handleEmbedThumbClick={this.handleEmbedThumbClick}
            video={video}
          />
        )}
        {isEmbedDropdownOpen && (
          <EmbedCodeDropdown
            embedDropdownOpen={isEmbedDropdownOpen}
            align={align}
            vAlign={vAlign}
            video={video}
          />
        )}
        {showLinkedGif && isGifDropdownOpen && (
          <EmbedThumbnailDropdown
            show={isGifDropdownOpen}
            align={align}
            vAlign={vAlign}
            video={video}
          />
        )}
      </div>
    );
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.show && this.props.show) {
      this.setState(DEFAULT_STATE);
    }
  }

  handleEmbedCodeClick = event => {
    event.stopPropagation();

    this.setState({ isEmbedDropdownOpen: true });

    analytics.track(SHARE_MENU_ACTION_EMBED);

    this.props.onHide();
  };

  handleEmbedThumbClick = event => {
    event.stopPropagation();

    this.setState({ isGifDropdownOpen: true });

    analytics.track(SHARE_MENU_ACTION_EMBED_THUMB_LINK);

    this.props.onHide();
  };

  handleClickOutside = () => {
    this.setState(DEFAULT_STATE);

    if (!this.props.show) {
      return;
    }

    this.props.onHide();
  };
}

export default onClickOutside(ShareDropdownMenu);
